"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSections = void 0;
var hooks_1 = require("../../hooks");
var useSections = function () { return (0, hooks_1.useAppSelector)(function (state) { return state.sections; }); };
exports.useSections = useSections;
